import { cleanDesc, getGameBySlug, getGameList } from "@/common/games"
import infoPages from "@/common/config/info-pages.json"

var SITE_NAME = "FreeGame"
var SITE_URL = (process.env.SITE_URL || "").replace(/\/$/, "")
var DEFAULT_IMAGE = "/static/files/p/ic_launcher120.png"
var DEFAULT_THEME_COLOR = "#050607"
var DEFAULT_ROBOTS = "index,follow,max-image-preview:large"
var DEFAULT_LOCALE = "en_US"

function buildAbsoluteUrl(path) {
  if (!SITE_URL) {
    return path
  }

  return SITE_URL + path
}

function ensureMeta(attr, key, content) {
  if (!content) {
    return
  }

  var selector = 'meta[' + attr + '="' + key + '"]'
  var el = document.head.querySelector(selector)

  if (!el) {
    el = document.createElement("meta")
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }

  el.setAttribute("content", content)
}

function ensureLink(rel, href) {
  if (!href) {
    return
  }

  var el = document.head.querySelector('link[rel="' + rel + '"]')

  if (!el) {
    el = document.createElement("link")
    el.setAttribute("rel", rel)
    document.head.appendChild(el)
  }

  el.setAttribute("href", href)
}

function baseSeo() {
  return {
    title: "Play Free Online Games | FreeGame",
    description: "Browse free online arcade games with instant browser play, fast loading pages, and dedicated landing pages for every title.",
    keywords: "free online games, browser games, arcade games, html5 games",
    path: "/",
    type: "website",
    image: DEFAULT_IMAGE,
    imageAlt: "FreeGame browser game library",
    robots: DEFAULT_ROBOTS,
    locale: DEFAULT_LOCALE,
    themeColor: DEFAULT_THEME_COLOR
  }
}

function buildHomeSeo() {
  var games = getGameList()
  var featuredGame = games.find(function(game) {
    return game.flag === "hot"
  }) || games[0]
  var seo = baseSeo()

  if (featuredGame) {
    seo.image = featuredGame.image
  }

  return seo
}

function buildGameSeo(game) {
  return {
    title: "Play " + game.name + " Online Free | " + SITE_NAME,
    description: cleanDesc(game.desc).slice(0, 155),
    keywords: [
      game.name,
      "play " + game.name + " online",
      game.name + " game",
      "free online game",
      "browser game",
      "html5 game",
      "no download game"
    ].join(", "),
    path: "/games/" + game.slug,
    type: "article",
    image: game.image,
    imageAlt: game.name + " cover image",
    robots: DEFAULT_ROBOTS,
    locale: DEFAULT_LOCALE,
    themeColor: DEFAULT_THEME_COLOR
  }
}

function buildInfoSeo(route) {
  var page = infoPages[route.meta.pageKey]

  if (!page) {
    return buildHomeSeo()
  }

  return {
    title: page.title + " | " + SITE_NAME,
    description: page.description,
    keywords: page.keywords,
    path: route.path,
    type: "website",
    image: DEFAULT_IMAGE,
    imageAlt: page.title + " page",
    robots: DEFAULT_ROBOTS,
    locale: DEFAULT_LOCALE,
    themeColor: DEFAULT_THEME_COLOR
  }
}

function getRouteSeo(route) {
  if (route.name === "Game") {
    var game = getGameBySlug(route.params.slug)

    if (game) {
      return buildGameSeo(game)
    }
  }

  if (route.meta && route.meta.pageKey) {
    return buildInfoSeo(route)
  }

  return buildHomeSeo()
}

function applyRouteSeo(route) {
  var seo = getRouteSeo(route)
  var canonicalUrl = buildAbsoluteUrl(seo.path)
  var imageUrl = seo.image && seo.image.indexOf("http") === 0 ? seo.image : buildAbsoluteUrl(seo.image)

  document.title = seo.title

  ensureMeta("name", "description", seo.description)
  ensureMeta("name", "keywords", seo.keywords)
  ensureMeta("name", "robots", seo.robots || DEFAULT_ROBOTS)
  ensureMeta("name", "googlebot", seo.robots || DEFAULT_ROBOTS)
  ensureMeta("name", "author", SITE_NAME)
  ensureMeta("name", "theme-color", seo.themeColor || DEFAULT_THEME_COLOR)
  ensureMeta("property", "og:site_name", SITE_NAME)
  ensureMeta("property", "og:locale", seo.locale || DEFAULT_LOCALE)
  ensureMeta("property", "og:title", seo.title)
  ensureMeta("property", "og:description", seo.description)
  ensureMeta("property", "og:type", seo.type)
  ensureMeta("property", "og:url", canonicalUrl)
  ensureMeta("property", "og:image", imageUrl)
  ensureMeta("property", "og:image:alt", seo.imageAlt || seo.title)
  ensureMeta("name", "twitter:card", "summary_large_image")
  ensureMeta("name", "twitter:title", seo.title)
  ensureMeta("name", "twitter:description", seo.description)
  ensureMeta("name", "twitter:image", imageUrl)
  ensureLink("canonical", canonicalUrl)
}

export {
  SITE_NAME,
  buildHomeSeo,
  buildGameSeo,
  getRouteSeo,
  applyRouteSeo
}



// WEBPACK FOOTER //
// ./src/common/seo.js